<!--代订收款-->
<template>
  <div class="OrderRoomType">
        <el-dialog 
            :visible.sync="collectionShow" 
            width="1000px"
            :z-index="9"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            center 
        >
            <div class="onDehalf-title mb-2">
                <div>报价详情</div>
                <!--关闭-->
                <span class="close" @click="$emit('onShow')"><i class="el-icon-close"></i></span>
            </div>
            <!--酒店详情-->
            <div class="travelHotel min-height">
                <div>
                    <div class="travel-desc">
                        <img v-lazy="$GFUN.formatImgSrc(orderDetail.hotel_top_pic,64,64)" class="hotel-img cursor-pointer"/>
                        <div class="travel-name">
                            <p class="title">
                                {{orderDetail.hotel_title}}
                                <img class="ml-1" v-lazy="'/images/zfxj/icon_'+orderDetail.hotel_state_star+'.png'" :key="orderDetail.hotel_state_star" height="18px" v-if="orderDetail.hotel_state_star>0"/>
                                <img class="ml-1" v-lazy="'/images/xj/icon_'+orderDetail.hotel_star+'.png'" :key="orderDetail.hotel_star" height="18px" v-else/>
                            </p>
                            <p>联系人: <span>{{orderDetail.offer_name}}</span></p>
                            <p>手机号: <span>{{orderDetail.offer_mobile}}</span></p>
                        </div>
                    </div>
                </div>
                <div class="frontDeskPhone none" v-if="orderDetail.offer_remark">报价说明：{{orderDetail.offer_remark||'无'}}</div>
            </div>
            <template>
                <OrderHousing :onDehalf="1" :orderDetail="orderDetail" ></OrderHousing>
                <!--操作按钮-->
                <div  class="onDehalf-bottoms">
                    <!--订单总额-->
                    <div class="price">
                        <!-- <div>订单总额：<span>¥{{ orderDetail.price_orig }}</span><p>¥{{ orderDetail.price }}</p></div> -->
                    </div>
                    <!-- <el-button  @click="submitOrder(1)"  type="primary" class="bottom" disabled >成交订单</el-button> -->
                    <el-button  @click="$emit('onShow')" class="bottom mr-3" size="small">返回</el-button>
                </div>
            </template>
        </el-dialog>
  </div>
</template>

<script>
import { mapState,mapActions} from 'vuex'
import OrderHousing from '../../Components/OrderHousing'
export default {
  name: 'OrderCollectionOnDehalf',
  components: {
    OrderHousing
  },
  props: {
    collectionShow: {
      type: Boolean,
      default: false
    },
    orderDetail: {
      type: Object,
      default: () => {
        return {
            broker:0
        }
      }
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created() {},
  mounted() {},
  methods: {
  }
};
</script>

<style lang="scss" scoped>
    .onDehalf-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        text-align: center;
        position: relative;
    }
    .noHint{
        text-align: center;
        margin-top: 20px;
        .img{
            width: 200px;
        }
        p{
            margin-top: 14px;
            color:#999
        }
    }
    .hint{
        width: 93%;
        background-color: var(--smtc-color-warning);
        color: #fff;
        margin: 0 auto;
        padding: 4px 2%;
        border-radius: 15px;
        font-size: 12px;
    }
    .onDehalf-bottoms{
        display: flex;
        justify-content:flex-end;
    }
    .base64Img{
        margin-top: 20px;
    }
    .hotel-title{
        font-size: 14px;
        font-weight: bold;
        margin-top: 10px;
    }
    .price{
        margin-right:auto;
        margin-left: 3%;
        line-height: 30px;
        color: var(--smtc-color-text-black);
        font-weight: bold;
        span{
            color: var(--smtc-color-text-shallow);
            text-decoration: line-through;
            margin-right: 6px;
            font-weight: normal;
            font-size: 12px;
        }
        p{
            display: inline-block;
            color: red;
        }
    }
    .close{
        position: absolute;
        top: 0px;
        right: 0px;
        color: #999;
        background-color: #f3f4f8;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        font-size: 12px;
        cursor: pointer;
    }
    
    .travelHotel{
        width: 90%;
        padding: 16px 3%;
        margin: 0 auto;
        background-color: #F5F7FA;
        border-radius: 6px;
    }
    .travel-title,.housing-title{
        font-weight: bold;
        font-size: 16px;
    }
    .travel-desc{
        display: flex;
        >img{
            width: 80px;
        }
        .travel-name{
            margin-left: 16px;
            height: 80px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            p{
                margin-top: 6px;

            }
            p:nth-child(1){
                font-size: 16px;
                font-weight: bold;
                margin-top:0;
            }
        }
    }
    .housing{
        width: 64%;
        padding: 16px 2%;
        background-color: #fff;
        border-radius: 6px;
    }
    .housing-list{
        display: flex;
        flex-wrap: wrap;
        li{
            width: 49%;
            margin-top: 12px;
            p{
                width: 80px;
                color: #999;
                float: left;
            }
            div{
                display: inline-block;
                width: 78%;
            }
        }
    }
    .title{

        font-weight: bold;  
        font-size: 16px;
        display: inline-flex;
        align-items: center; /* 图片垂直居中 */
    }
    .frontDeskPhone{
        margin-top: 8px;
        padding-top: 8px;
        font-size: 12px;
        color: #666;
    }
    .none{
        border-top: none;
        margin-top: 4px;
        padding-top: 4px;
    }
</style>
<style >
    .OrderRoomType .el-dialog__header{
        padding: 0;
        padding-bottom:0;
    }
    .OrderRoomType .el-dialog__headerbtn{
        background-color: #f3f4f8;
        border-radius: 50px;
        width: 24px;
        height: 24px;
        font-size: 14px;
    }
    .OrderRoomType .el-dialog__headerbtn .el-dialog__close{
        color:#999;
    }
</style>